import { gql } from '@biletiniz/apollo';

export const FORGOT_PASSWORD = gql`
  mutation forgotPassword($username: String!) {
    forgotPassword(username: $username) {
      status
      message
    }
  }
`;
